<template>
	<div>
		<b-card no-body class="mb-1">
			<div class="m-2">
				<div class="mx-2 mb-2">
					<b-row>
						<b-col
							cols="12"
							sm="6"
							class="d-flex align-items-center justify-content-center justify-content-sm-start"
						>
							<span class="text-muted">
								Mostrando {{ start_page }} a {{ to_page }} de {{ total_data }} registros
							</span>
						</b-col>
						<!-- Pagination -->
						<b-col
							cols="12"
							sm="6"
							class="d-flex align-items-center justify-content-center justify-content-sm-end"
						>
							<b-pagination
								v-model="current_page"
								:total-rows="total_data"
								:per-page="perpage"
								first-number
								last-number
								class="mb-0 mt-1 mt-sm-0"
								prev-class="prev-item"
								next-class="next-item"
							>
								<template #prev-text>
									<feather-icon icon="ChevronLeftIcon" size="18" />
								</template>
								<template #next-text>
									<feather-icon icon="ChevronRightIcon" size="18" />
								</template>
							</b-pagination>
						</b-col>
					</b-row>
				</div>
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->

					<b-col cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
						<label>Mostrar</label>
						<v-select
							v-model="perpage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label class="mr-2">registros</label>
						<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="resetData" />
					</b-col>
					<!-- Search -->
					<b-col cols="12" md="8">
						<!-- <div class="d-flex align-items-center justify-content-end"> -->
						<b-row>
							<b-col cols="12" lg="3" md="6">
								<b-form-group>
									<b-form-datepicker
										id="from"
										:date-format-options="{
											year: 'numeric',
											month: 'numeric',
											day: 'numeric',
										}"
										placeholder="Desde"
										locale="es"
										v-model="from"
									></b-form-datepicker>
								</b-form-group>
							</b-col>
							<b-col cols="12" lg="3" md="6">
								<b-form-group>
									<b-form-datepicker
										id="to"
										:date-format-options="{
											year: 'numeric',
											month: 'numeric',
											day: 'numeric',
										}"
										placeholder="Hasta"
										locale="es"
										v-model="to"
									></b-form-datepicker>
								</b-form-group>
							</b-col>
							<b-col cols="12" lg="6" md="12">
								<div class="d-flex align-items-center justify-content-end">
									<b-input-group class="mr-1">
										<b-form-input placeholder="Search..." v-model="search_input" debounce="500" />
										<b-input-group-append>
											<b-button variant="outline-primary" @click="refreshTable">
												<feather-icon icon="SearchIcon" />
											</b-button>
										</b-input-group-append>
									</b-input-group>
									<b-button
										variant="outline-primary"
										:to="{ name: 'administrativo-agregar-depositos-sr' }"
										v-if="isAdmin"
									>
										<span class="text-nowrap">Agregar depósito</span>
									</b-button>
								</div>
							</b-col>
						</b-row>
						<!-- <b-button variant="outline-primary" to="/ejemplares/crear">
                <span class="text-nowrap">Agregar ejemplar</span>
              </b-button> -->
						<!-- </div> -->
					</b-col>
				</b-row>
			</div>
			<div class="table-responsive">
				<b-table
					:api-url="'/api/administrative/get-transactions'"
					ref="refUserListTable"
					class="position-relative"
					:items="myProvider"
					stacked="lg"
					:fields="arrayColumns"
					primary-key="id"
					table-class="text-nowrap"
					responsive
					small
					show-empty
					:busy.sync="isBusy"
					empty-filtered-text="No hay registros que coincidan con tu búsqueda."
					empty-text="No hay registros que mostrar."
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:current-page="current_page"
					:per-page="perpage"
					:filter="search_input"
				>
					<template #table-busy>
						<div class="text-center text-primary my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong>Cargando...</strong>
						</div>
					</template>
					<template #cell(type)="data">
						{{ data.item.type_number == 1 ? "GASTO" : "DEPÓSITO" }}
					</template>
					<template #cell(total)="data">
						<money
							class="input-form text-center"
							v-model="data.item.total"
							v-bind="money"
							id="bank_detail"
							disabled
							style="background: transparent; border: none"
						></money>
					</template>
					<template #cell(transaction_date)="data">
						{{ data.item.transaction_date | myGlobalDayShort }}
					</template>
					<template #cell(created_by)="data">
						{{ data.item.name }} {{ data.item.last_name }}
						<br />
						{{ data.item.created_at | myGlobalDayShort }}
					</template>
					<template #cell(actions)="data">
						<router-link
							:to="{
								name: 'administrativo-detalle-depositos-sr',
								params: { transaction_id: data.item.id },
							}"
						>
							<feather-icon
								v-if="isAdmin && !data.item.is_assigned_plate"
								class="cursor-pointer text-info mr-1"
								icon="EyeIcon"
								size="20"
								:id="`edit-tooltip${data.index}`"
							/>
							<b-tooltip :target="`edit-tooltip${data.index}`" placement="top">Editar</b-tooltip>
						</router-link>
						<feather-icon
							v-if="isAdmin && !data.item.is_assigned_plate"
							class="cursor-pointer text-danger"
							@click="deleteTransaction(data.item.id)"
							icon="TrashIcon"
							size="20"
							:id="`delete-tooltip${data.index}`"
						/>
						<b-tooltip :target="`delete-tooltip${data.index}`" placement="top">Eliminar</b-tooltip>
					</template>
				</b-table>
			</div>
			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span class="text-muted">
							Mostrando {{ start_page }} a {{ to_page }} de {{ total_data }} registros
						</span>
					</b-col>
					<!-- Pagination -->
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="current_page"
							:total-rows="total_data"
							:per-page="perpage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon icon="ChevronLeftIcon" size="18" />
							</template>
							<template #next-text>
								<feather-icon icon="ChevronRightIcon" size="18" />
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>
	</div>
</template>

<script>
import vSelect from "vue-select"
import { Money } from "v-money"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
export default {
	components: {
		Money,
		vSelect,
	},
	data() {
		return {
			sortBy: "type",
			sortDesc: false,
			arrayColumns: [
				{
					key: "transaction_date",
					label: "Fecha",
					class: "text-center",
					sortable: true,
				},
				{ key: "type", label: "Tipo", class: "text-center" },
				{
					key: "memo",
					label: "Memo",
					class: "text-center ",
					sortable: true,
				},
				{
					key: "total",
					label: "Total",
					class: "text-center ",
					sortable: true,
				},
				{ key: "created_by", label: "Creado por", class: "text-center" },
				{ key: "actions", label: "Acciones", class: "text-center " },
			],
			perPageOptions: [10, 25, 50, 100],
			//   myProvider: [],
			search_input: "",
			orderby: this.dato2 == null ? 3 : this.dato2,
			order: this.dato1 == null ? "desc" : this.dato1,
			start_page: "",
			end_page: "",
			total_data: "",
			perpage: 1000,
			next_page: "",
			current_page: 1,
			to_page: "",
			dato1: "",
			dato2: "",
			from: null,
			to: null,
			loadingData: false,
			isBusy: false,
			modalGastoController: false,
			money: {
				decimal: ".",
				thousands: ",",
				prefix: "S/. ",
				precision: 2,
				masked: false,
			},
			selectedTransactionId: null,
		}
	},
	methods: {
		resetData() {
			;(this.search_input = ""),
				(this.orderby = this.dato2 == null ? 3 : this.dato2),
				(this.order = this.dato1 == null ? "desc" : this.dato1),
				(this.start_page = ""),
				(this.end_page = ""),
				(this.total_data = ""),
				(this.perpage = 100),
				(this.next_page = ""),
				(this.current_page = 1),
				(this.to_page = ""),
				(this.dato1 = ""),
				(this.dato2 = "")
			this.from = null
			this.to = null
			this.$refs.refUserListTable.refresh()
		},
		closeModal() {
			this.modalGastoController = false
			this.$refs.refUserListTable.refresh()
		},
		refreshTable() {
			this.$refs.refUserListTable.refresh()
		},
		myProvider(ctx) {
			const promise = axios.post(
				// "/some/url?page=" + ctx.currentPage + "&size=" + ctx.perPage
				`${ctx.apiUrl}?page=${ctx.currentPage}`,
				{
					orderby: ctx.sortDesc,
					order: ctx.sortBy == "" ? "type" : ctx.sortBy,
					campo: ctx.filter,
					perpage: ctx.perPage,
					type: 2,
					from: this.from,
					to: this.to,
				}
			)
			// Must return a promise that resolves to an array of items
			return promise.then((data) => {
				// Pluck the array of items off our axios response
				const items = data.data.data
				this.start_page = data.data.from
				this.current_page = data.data.current_page
				this.perpage = data.data.per_page
				this.next_page = this.start_page + 1
				this.end_page = data.data.last_page
				this.total_data = data.data.total
				this.to_page = data.data.to
				// Must return an array of items or an empty array if an error occurred
				return items || []
			})
		},
		saveTransaction() {
			this.$refs.createTransactionRef.upload(2)
		},
		showToast(variant, position, title, icon, text) {
			this.$toast(
				{
					component: ToastificationContent,
					props: {
						title,
						icon,
						text,
						variant,
					},
				},
				{
					position,
				}
			)
		},
		deleteTransaction(transaction) {
			this.$swal({
				title: "Estas seguro?",
				text: "¡No podrás revertir esto!",
				icon: "warning",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				confirmButtonText: "Confirmar",
				customClass: {
					cancelButton: "btn btn-outline-danger ml-1",
					confirmButton: "btn btn-primary",
				},
				buttonsStyling: false,
			}).then((result) => {
				if (result.value) {
					axios
						.post("/api/administrative/delete-transaction", {
							deleted_by: this.currentUser.user_id,
							transaction_id: transaction,
						})
						.then((res) => {
							this.showToast("success", "top-right", "Felicidades", "CheckIcon", "Depósito eliminado!")
							this.refreshTable()
						})
				}
			})
		},
	},
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>
